export function formatBrazilianPhone(value: string | null | undefined): string {
  const original = value?.trim() ?? "";
  const digits = original.replace(/\D/g, "");
  const hasCountry = digits.length === 13 && digits.startsWith("55");
  const local = hasCountry ? digits.slice(2) : digits;
  const prefix = hasCountry ? "+55 " : "";
  if (local.length === 11) return `${prefix}(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`;
  if (local.length === 10) return `${prefix}(${local.slice(0, 2)}) ${local.slice(2, 6)}-${local.slice(6)}`;
  return original;
}

export function isMapaRegulatedPrescription(regime: string | null | undefined): boolean {
  return regime === "manipulated_controlled_mapa";
}

export function resolveMapaPresentation(input: { controlRegime?: string | null; snapshotRegistration?: string | null; snapshotIdentifier?: string | null; legacyMapaNumber?: string | null; profileMapaNumber?: string | null }): { registration: string | null; identifier: string | null } {
  const supportsIdentifier = isMapaRegulatedPrescription(input.controlRegime);
  if (input.snapshotRegistration || input.snapshotIdentifier) return { registration: input.snapshotRegistration?.trim() || input.profileMapaNumber?.trim() || null, identifier: supportsIdentifier ? input.snapshotIdentifier?.trim() || null : null };
  const legacy = input.legacyMapaNumber?.trim() || "";
  const match = legacy.match(/^([^/]+)\/([0-9]+)\/([0-9]{2})$/);
  if (match) return { registration: match[1].trim(), identifier: supportsIdentifier ? legacy : null };
  return { registration: legacy || input.profileMapaNumber?.trim() || null, identifier: null };
}
